// profile/ProfileHeader.jsx
import React from 'react';
// ブランドロゴ表示用（npm install react-icons 済み想定）
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import styles from './styles/ProfileHeader.module.css';
import SocialLinks from './SocialLinks';

const normalizeUrl = (url) => {
  if (!url) return '';
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return 'https://' + trimmed;
};

const ProfileHeader = ({ user, isOwner }) => {
  const navigate = useNavigate();
  // 購入者のマイページではヘッダを表示しない
  if (user?.role === 'buyer' && isOwner) return null;
  return (
    <div className={styles.profileHeader}>
      <div className={styles.imageWrapper}>
        <img
          src={user.profile_image_url || '/default-profile.png'}
          alt="プロフィール画像"
          className={styles.profileImage}
        />
      </div>
      <div className={styles.info}>
        <h2 className={styles.name}>
          {user.organization_name}
          {(user.instagram || user.twitter) && (
            <span className={styles.socialInline}>
              {user.instagram && (
                <a
                  href={normalizeUrl(user.instagram)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              )}
              {user.twitter && (
                <a
                  href={normalizeUrl(user.twitter)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label="X (旧Twitter)"
                  title="X"
                >
                  <FaXTwitter />
                </a>
              )}
            </span>
          )}
        </h2>
        {(user.description || user.bio) && <p className={styles.bio}>{user.description || user.bio}</p>}
        <SocialLinks links={user.social_links} />
        {isOwner && (
          <button className={styles.editButton} onClick={() => navigate('/profile/edit')}>プロフィール編集</button>
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;